import './faq.scss';

let skipNextScroll = false;

function scrollFaqItemIntoView(el) {
  const item = el.closest('.faq');
  if (!item) return;

  const scrollToItem = () => {
    item.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      scrollToItem();
    });
  });

  setTimeout(scrollToItem, 150);
}

function initCollectionTopics(faqComponent) {
  faqComponent.querySelectorAll('.faq.faq--collection[id]').forEach((faqRoot) => {
    const nav = faqRoot.querySelector('.faq-collection-nav');
    if (!nav) return;

    const navItems = faqRoot.querySelectorAll('.faq-collection-item[data-topic-index]');
    const topicSections = faqRoot.querySelectorAll('.faq-collection-content .faq-topic[id]');

    if (!navItems.length || !topicSections.length) return;

    const rootId = faqRoot.id;

    const tablist = faqRoot.querySelector('.faq-collection-list[role="tablist"]');

    function getTopicButtons() {
      return Array.from(faqRoot.querySelectorAll('.faq-topic-nav-btn[data-topic-index]'));
    }

    function setRovingTabindex(activeIndex) {
      getTopicButtons().forEach((btn) => {
        const isActive = btn.dataset.topicIndex === String(activeIndex);
        btn.setAttribute('tabindex', isActive ? '0' : '-1');
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function activateTopic(index, updateHash) {
      const topicId = `${rootId}-topic-${index}`;

      navItems.forEach((li) => {
        const isActive = li.dataset.topicIndex === String(index);
        li.classList.toggle('is-active', isActive);
      });

      setRovingTabindex(index);

      getTopicButtons().forEach((btn) => {
        const isActive = btn.dataset.topicIndex === String(index);
        btn.classList.toggle('active', isActive);
      });

      topicSections.forEach((section) => {
        const isActive = section.id === topicId;

        section.classList.toggle('is-active', isActive);
        section.classList.toggle('active', isActive);
        section.classList.toggle('show', isActive);
        section.toggleAttribute('hidden', !isActive);
      });

      if (updateHash) {
        history.replaceState(null, '', `#${topicId}`);
      }
    }

    nav.addEventListener('click', (e) => {
      const btn = e.target.closest('.faq-topic-nav-btn[data-topic-index]');
      if (!btn) return;

      const index = btn.dataset.topicIndex;
      activateTopic(index, true);
    });

    (tablist || nav).addEventListener('keydown', (e) => {
      const btn = e.target.closest('.faq-topic-nav-btn[role="tab"]');
      if (!btn) return;

      const buttons = getTopicButtons();
      const currentIndex = buttons.indexOf(btn);
      if (currentIndex < 0) return;

      let nextIndex = currentIndex;

      switch (e.key) {
        case 'ArrowDown':
        case 'ArrowRight':
          e.preventDefault();
          nextIndex = (currentIndex + 1) % buttons.length;
          break;

        case 'ArrowUp':
        case 'ArrowLeft':
          e.preventDefault();
          nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
          break;

        case 'Home':
          e.preventDefault();
          nextIndex = 0;
          break;

        case 'End':
          e.preventDefault();
          nextIndex = buttons.length - 1;
          break;

        case 'Enter':
        case ' ':
          e.preventDefault();
          activateTopic(btn.dataset.topicIndex, true);
          return;

        default:
          return;
      }

      const nextBtn = buttons[nextIndex];
      if (!nextBtn) return;

      nextBtn.focus();
      activateTopic(nextBtn.dataset.topicIndex, true);
    });

    const hash = window.location.hash;
    const match =
      hash && hash.startsWith(`#${rootId}-topic-`) ? hash.match(new RegExp(`^#${rootId}-topic-(\\d+)$`)) : null;

    if (match && match[1] != null) {
      activateTopic(match[1], false);
    } else {
      const anyActive = faqRoot.querySelector('.faq-collection-item.is-active');

      let index = null;

      if (anyActive && anyActive.dataset && anyActive.dataset.topicIndex != null) {
        index = anyActive.dataset.topicIndex;
      } else if (navItems[0] && navItems[0].dataset && navItems[0].dataset.topicIndex != null) {
        index = navItems[0].dataset.topicIndex;
      }

      if (index != null) {
        activateTopic(index, false);
      }
    }
  });
}

function ensureCollectionTopicVisibleForElement(element) {
  const faqRoot = element.closest('.faq.faq--collection[id]');
  if (!faqRoot) return;

  const rootId = faqRoot.id;

  const section = element.classList.contains('faq-topic') ? element : element.closest('.faq-topic[id]');
  if (!section) return;

  const match = section.id.match(new RegExp(`^${rootId}-topic-(\\d+)$`));
  if (!match) return;

  const topicIndex = match[1];

  const navItems = faqRoot.querySelectorAll('.faq-collection-item[data-topic-index]');
  const topicSections = faqRoot.querySelectorAll('.faq-collection-content .faq-topic[id]');

  navItems.forEach((li) => {
    li.classList.toggle('is-active', li.dataset.topicIndex === String(topicIndex));
  });

  faqRoot.querySelectorAll('.faq-topic-nav-btn[data-topic-index]').forEach((button) => {
    const isActive = button.dataset.topicIndex === String(topicIndex);
    button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    button.setAttribute('tabindex', isActive ? '0' : '-1');
    button.classList.toggle('active', isActive);
  });

  topicSections.forEach((section) => {
    const isActive = section.id === `${rootId}-topic-${topicIndex}`;

    section.classList.toggle('is-active', isActive);
    section.classList.toggle('active', isActive);
    section.classList.toggle('show', isActive);
    section.toggleAttribute('hidden', !isActive);
  });
}

function handleFaqDeepLink(faqComponent) {
  const hash = window.location.hash;
  if (!hash) return;

  const element = faqComponent.querySelector('.faq ' + hash);
  if (!element) return;

  if (element.classList && element.classList.contains('faq-topic') && element.closest('.faq.faq--collection')) {
    ensureCollectionTopicVisibleForElement(element);

    scrollFaqItemIntoView(element);
    return;
  }

  if (element.classList && element.classList.contains('collapse') && element.closest('.faq')) {
    const topicSection = element.closest('.faq-topic[id]');
    if (topicSection) {
      ensureCollectionTopicVisibleForElement(topicSection);
    }

    scrollFaqItemIntoView(element);

    const instance = window.bootstrap.Collapse.getOrCreateInstance(element, { toggle: false });

    skipNextScroll = true;
    instance.show();
  }
}

function isElementHiddenByDisplay(el) {
  if (!el) return true;
  const style = window.getComputedStyle(el);
  return style.display === 'none';
}

function isElementVisibleByDisplay(el) {
  return !isElementHiddenByDisplay(el);
}

function handleMobileCollection(faqComponent) {
  const mobileCollection = faqComponent.querySelector('.faq.faq--collection.mobile');
  const desktopCollection = faqComponent.querySelector('.faq.faq--collection:not(.mobile)');
  if (!mobileCollection || !desktopCollection) return;

  if (isElementVisibleByDisplay(mobileCollection)) {
    desktopCollection.remove();
  } else {
    mobileCollection.remove();
  }
}

function initFaqAnalyticsAttributes() {
  document.querySelectorAll('.faq-component .faq-item').forEach((faqItem) => {
    const faqButton = faqItem.querySelector('button.faq-toggle');
    if (!faqButton) return;

    const area = faqButton.getAttribute('data-layer-area') || 'main';
    const subarea = faqButton.getAttribute('data-layer-subarea') || 'body';
    const typeoffaq = faqButton.getAttribute('data-layer-typeoffaq') || '';
    const id = faqButton.id || '';

    faqItem.querySelectorAll('.faq-answer a').forEach((anchor) => {
      anchor.classList.add('mh-emit-dynamic-link');
      anchor.dataset.layerComp = 'faq';
      anchor.dataset.layerArea = area;
      anchor.dataset.layerSubarea = subarea;
      anchor.dataset.layerTypeoffaq = typeoffaq;
      anchor.dataset.layerId = id;
      anchor.dataset.layerExpanded = faqButton.getAttribute('aria-expanded') || 'false';
    });
  });

  document.addEventListener('shown.bs.collapse', (e) => {
    const faqItem = e.target.closest('.faq-item');
    if (!faqItem) return;
    faqItem.querySelectorAll('.faq-answer a.mh-emit-dynamic-link').forEach((anchor) => {
      anchor.dataset.layerExpanded = 'true';
    });
  });

  document.addEventListener('hidden.bs.collapse', (e) => {
    const faqItem = e.target.closest('.faq-item');
    if (!faqItem) return;
    faqItem.querySelectorAll('.faq-answer a.mh-emit-dynamic-link').forEach((anchor) => {
      anchor.dataset.layerExpanded = 'false';
    });
  });
}

function init() {
  const faqComponents = document.querySelectorAll('.faq-component');

  if (!faqComponents.length) {
    return;
  }

  faqComponents.forEach((faqComponent) => {
    handleMobileCollection(faqComponent);
    handleFaqDeepLink(faqComponent);
    initCollectionTopics(faqComponent);
  });

  initFaqAnalyticsAttributes();

  document.addEventListener('shown.bs.collapse', (e) => {
    const collapseEl = e.target;

    if (!collapseEl || !collapseEl.classList.contains('collapse') || !collapseEl.closest('.faq')) {
      return;
    }

    history.replaceState(null, '', `#${collapseEl.id}`);

    if (skipNextScroll) {
      skipNextScroll = false;
      return;
    }
  });
}

setTimeout(() => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}, 1000);
